export default {
  authentication: {
    components: {
      forgottenPassword: {
        backButtonText: 'Zpět'
      },
      login: {
        emailAccount: {
          backButtonText: 'Zpět'
        },
        newPasswordRequired: {
          passwordPolicy: {
            copy: '_TODO: We\'ve updated our password policy to improve account security. Your account is still safe but a new password is required.'
          },
          instructionsLineOne: '_TODO: You\'ll receive an email to set a new password.',
          instructionsLineTwo: 'Zkontrolujte prosím všechny složky v doručené poště, včetně spamu.',
          resendEmailCopy: 'Neobdrželi jste e-mail? ',
          resendEmailButtonText: 'Kliknutím odešlete znovu'
        }
      },
      registration: {
        contactPreferences: {
          skipButtonText: 'Přeskočit tento krok '
        },
        createAccount: {
          backButtonText: 'Zpět'
        }
      }
    },
    hooks: {
      useAccountLogin: {
        error: {
          submissionError: {
            message: 'Váš email a/nebo heslo jsou nesprávné. Zkuste to znovu nebo vyberte Zapomenuté heslo.'
          }
        }
      },
      useAuthPageProps: {
        landing: {
          heading: 'Vytvořit účet.',
          title: 'Vytvořit účet'
        },
        loginLanding: {
          heading: 'Přihlásit se.',
          title: 'Přihlásit se'
        },
        loginForm: {
          heading: 'Přihlásit se.',
          title: 'Přihlásit se'
        },
        loginVerifyAccount: {
          heading: '_TODO: Your account is not yet verified.',
          title: '_TODO: Verification required'
        },
        createAccount: {
          heading: 'Vytvořit účet.',
          title: 'Vytvořit účet'
        },
        resetPassword: {
          heading: 'Zapomněli jste heslo?',
          title: 'Zapomněli jste heslo?'
        },
        changeEmailConfirmation: {
          heading: '_TODO: Enter your password.',
          title: '_TODO: Enter your password'
        },
        contactPreferences: {
          heading: 'Zůstaňme v kontaktu.',
          title: 'Zůstaňme v kontaktu'
        },
        forgottenPassword: {
          "default": {
            heading: 'Zapomněli jste heslo?',
            title: 'Zapomněli jste heslo?'
          }
        },
        emailSentConfirmation: {
          verifyAccount: {
            heading: 'Ověřme váš účet.',
            title: 'Ověřte svůj účet'
          },
          resetPassword: {
            heading: '_TODO: Check your inbox.',
            title: '_TODO: Check your inbox'
          }
        },
        newPasswordRequired: {
          "default": {
            heading: '_TODO: Check your inbox.',
            title: '_TODO: Check your inbox'
          }
        },
        success: {
          "default": {
            heading: 'Hotovo, všechno je správně nastaveno!',
            title: 'Hotovo, všechno je správně nastaveno!'
          },
          accountAlreadyVerified: {
            heading: 'Váš účet je už ověřený.',
            title: 'Váš účet je už ověřený'
          },
          changeEmail: {
            heading: '_TODO: You\'re all set up and ready to go!',
            title: '_TODO: You\'re all set up and ready to go!'
          },
          loginAccountVerified: {
            heading: '_TODO: Your account is now verified.',
            title: '_TODO: Your account is now verified'
          },
          resetPassword: {
            heading: 'Vaše heslo bylo změněno.',
            title: 'Vaše heslo bylo změněno'
          }
        },
        error: {
          "default": {
            heading: 'Vytvořit účet.',
            title: 'Něco neproběhlo zcela správně'
          },
          errorWithRetrySignUp: {
            heading: 'Něco neproběhlo zcela správně.',
            title: 'Něco neproběhlo zcela správně'
          },
          errorWithResendEmail: {
            heading: 'Něco se pokazilo.',
            title: 'Něco se pokazilo'
          },
          linkExpiredWithResendEmail: {
            heading: 'Link na ověření účtu už expiroval.',
            title: 'Link na ověření účtu už expiroval'
          },
          loginGeneralError: {
            heading: 'Přihlásit se.',
            title: 'Něco neproběhlo zcela správně'
          },
          loginVerificationErrorWithRetry: {
            heading: 'Něco neproběhlo zcela správně.',
            title: 'Něco neproběhlo zcela správně'
          },
          loginVerificationErrorWithResendEmail: {
            heading: 'Něco se pokazilo.',
            title: 'Něco se pokazilo'
          },
          loginVerificationLinkExpiredWithResendEmail: {
            heading: 'Link na ověření účtu už expiroval.',
            title: 'Link na ověření účtu už expiroval'
          },
          passwordResetTokenExpired: {
            heading: '_TODO: Password link expired.',
            title: '_TODO: Password link expired'
          },
          changeEmailVerifyLinkGeneralError: {
            heading: '_TODO: Sorry, something went wrong.',
            title: '_TODO: Sorry, something went wrong'
          },
          changeEmailVerifyLinkInvalid: {
            heading: '_TODO: Your email address hasn\'t changed.',
            title: '_TODO: Your email address hasn\'t changed'
          }
        }
      },
      useAuthStatusProps: {
        success: {
          changeEmail: {
            buttonText: '_TODO: Take me back to where I started',
            heading: '_TODO: Success!',
            subheading: '_TODO: You\'re all set! Let\'s get you back on your journey.'
          },
          login: {
            accountVerified: {
              buttonText: 'Přihlásit se',
              heading: 'Hotovo!'
            }
          },
          registration: {
            buttonText: 'Zpátky na začátek',
            buttonTextLogin: 'Pro přihlášení klikněte sem',
            heading: 'Hotovo!',
            subheading: 'Přihlášená/-ý jako:'
          },
          resetPassword: {
            buttonText: 'Příhlásit se k vašemu účtu ',
            loggedInButtonText: 'Hotovo',
            contentPartOne: 'Heslo můžete kdykoliv změnit v části ',
            contentPartTwo: 'nastavení účtu'
          }
        },
        error: {
          changeEmailVerifyLinkGeneralError: {
            buttonText: '_TODO: Go to My Account',
            content: '_TODO: Any changes you made may not be saved, please go back to My Account and try again.'
          },
          changeEmailVerifyLinkInvalid: {
            buttonText: '_TODO: Resend email',
            content: '_TODO: Sorry, that didn\'t work. Please click below to send a new link.'
          },
          registration: {
            buttonText: 'Zkuste znovu',
            heading: 'Něco neproběhlo zcela správně',
            subheading: 'Zkuste se registrovat znovu.'
          },
          resetPassword: {
            withRetry: {
              buttonText: '_TODO: Retry',
              content: 'Klikněte níže a zkuste to znovu.'
            },
            withResendEmail: {
              buttonText: '_TODO: Resend email',
              content: '_TODO: Sorry about that! Try clicking below to send a new verification email.'
            },
            tokenExpired: {
              buttonText: '_TODO: Resend email',
              content: '_TODO: The link we sent you is no longer valid, we do this to keep your account secure. Click below to send a new forgotten password email.'
            }
          },
          login: {
            generalLoginError: {
              heading: '_TODO: Something didn\'t go quite right',
              subheading: '_TODO: Please try logging in again later',
              buttonText: '_TODO: Try again'
            },
            verificationErrorWithResendEmail: {
              buttonText: '_TODO: Resend verification email',
              content: '_TODO: Sorry about that! Try clicking below to send a new verification email.'
            },
            verificationErrorWithRetry: {
              buttonText: '_TODO: Retry',
              content: '_TODO: We\'ve encountered an issue while attempting to verify your account. Please try logging in again and we\'ll send you a new verification email. Alternatively, contact support at the address below.'
            },
            verificationLinkExpiredWithResendEmail: {
              buttonText: '_TODO: Resend verification email',
              content: '_TODO: The link we sent you is no longer valid, we do this to keep your account secure. Click below to send a new verification email.'
            },
            verificationRequired: {
              buttonText: '_TODO: Resend verification email',
              content: '_TODO: We recently sent you a link to verify your account. This is to keep your account secure. This link may have expired, please click below to send a new link.'
            }
          }
        }
      },
      useChangeEmailConfirmation: {
        error: {
          submissionError: {
            incorrectPassword: '_TODO: Your password is incorrect'
          }
        }
      },
      useStepperProps: {
        steps: {
          first: 'Přihlásit se',
          second: 'Nastavení',
          third: 'Hotovo'
        }
      }
    },
    toastNotifications: {
      success: {
        genericEmailReSent: '_TODO: Email has been re-sent.',
        verificationEmailReSent: '_TODO: Verification email has been re-sent.'
      },
      error: {
        genericErrorMessage: '_TODO: Something went wrong. Please try again.',
        verificationEmailFailed: '_TODO: Failed to send verification email.'
      }
    }
  },
  myHub: {
    collection: {
      calloutText: 'Ukládejte si obsah a vytvářejte vlastní kolekce díky bezplatnému účtu.',
      errorMessage: 'Nelze načíst další položky. Prosím zkuste to znovu později.',
      loadNext: 'Načíst další',
      taglineItem_one: 'položka',
      taglineItem_few: 'položky',
      taglineItem_many: 'položek',
      taglineItem_other: 'položek',
      taglineItem: 'položka',
      taglineItem_plural: 'položek',
      taglineItem_0: 'položka',
      taglineItem_1: 'položky',
      taglineItem_2: 'položek'
    },
    collections: {
      taglineSaved: 'uloženo',
      createButtonText: 'Vytvořit novou kolekci',
      loadErrorMessage: 'Nelze načíst další položky. Prosím zkuste to znovu později.',
      loadNext: 'Načíst další',
      tagline_one: 'kolekce',
      tagline_few: 'kolekce',
      tagline_many: 'kolekcí',
      tagline_other: 'kolekcí',
      tagline: 'kolekce',
      tagline_plural: 'kolekcí',
      tagline_0: 'kolekce',
      tagline_1: 'kolekce',
      tagline_2: 'kolekcí'
    },
    components: {
      accountSettings: {
        banner: {
          changeEmailCheckInbox: {
            text1: '_TODO: We have sent an email to {{email}}',
            text2: '_TODO: Please click the link in your email to change your email address.'
          },
          error: {
            text1: '_TODO: Oops something went wrong! Any changes you made may not be saved.',
            text2: '_TODO: Please try again later or contact us if the problem persists at {{supportEmail}}'
          },
          contactPreferences: {
            text1: '_TODO: Here is a list of emails you are subscribed to. We won\'t send you anything that you haven\'t selected.',
            text2: '_TODO: For more information about how Immediate Media uses your personal information, and the rights you have in relation to that information, please see our {{privacyPolicy}}.',
            privacyPolicy: '_TODO: Privacy Policy'
          },
          loadingError: {
            text1: '_TODO: We ran into a problem trying to load your contact preferences. Please try again later or contact us if the problem persists at {{supportEmail}}',
            text2: '_TODO: Rest assured your data is safe and we will never send you anything that you haven\'t selected.'
          }
        },
        myDetails: {
          layoutTitle: '_TODO: Account Settings',
          layoutSubtitle: '_TODO: My Details',
          basicInfoSection: {
            title: '_TODO: Basic info',
            editButtonLabel: '_TODO: Click here to edit'
          },
          accountManagementSection: {
            title: '_TODO: Account management'
          }
        },
        contactPreferences: {
          layoutTitle: '_TODO: Account Settings',
          layoutSubtitle: '_TODO: Contact Preferences'
        }
      },
      savedItem: {
        card: {
          ariaLabel: {
            save: 'Uložit',
            unsave: 'Zrušit uložení'
          }
        }
      },
      searchFilter: {
        ariaLabel: {
          searchButton: 'hledat'
        },
        filteredResultsHeading: 'Zobrazit výsledky pro:',
        sr: {
          filteredItemsResults_one: 'výsledek',
          filteredItemsResults_few: 'výsledky',
          filteredItemsResults_many: 'výsledků',
          filteredItemsResults_other: 'výsledků',
          filteredItemsResults: 'výsledek',
          filteredItemsResults_plural: 'výsledků',
          filteredItemsResults_0: 'výsledek',
          filteredItemsResults_1: 'výsledky',
          filteredItemsResults_2: 'výsledků'
        }
      }
    },
    hooks: {
      useResponseCodes: {
        firstName: {
          tooLong: '_TODO: First name must be no longer than 100 characters'
        },
        lastName: {
          tooLong: '_TODO: Last name must be no longer than 100 characters'
        },
        screenName: {
          notUnique: '_TODO: This screen name has already been taken',
          tooLong: '_TODO: Screen name must be no longer than 100 characters'
        },
        email: {
          invalid: '_TODO: Please enter a valid email address',
          notUnique: '_TODO: This email address has already been taken',
          tooLong: '_TODO: Email address must be no longer than 100 characters'
        },
        oldPassword: {
          incorrectPassword: '_TODO: Your password is incorrect'
        },
        newPassword: {
          isSameAsOldPassword: '_TODO: New password cannot be the same as your current password'
        }
      }
    },
    overview: {
      createButtonText: 'Vytvořit novou kolekci',
      defaultTitle: 'Moje místo',
      ugcButtonLabel: 'Zobrazit více',
      ugcCreateButtonText: 'Vložit recept'
    },
    ownItems: {
      createButtonText: 'vložit nový recept',
      loadErrorMessage: 'Nelze načíst další položky. Prosím zkuste to znovu později.',
      loadNext: 'Načíst další',
      tabData: {
        all: 'Všechno',
        published: 'Publikováno',
        unpublished: 'Nepublikováno'
      },
      tabFilterError: 'Nastal problém při filtrovaní vašich receptů. Zobrazujeme místo toho všechny recepty.'
    },
    savedItems: {
      collectionTaglineItem_one: 'položka',
      collectionTaglineItem_few: 'položky',
      collectionTaglineItem_many: 'položek',
      collectionTaglineItem_other: 'položek',
      collectionTaglineItem: 'položka',
      collectionTaglineItem_plural: 'položek',
      collectionTaglineItem_0: 'položka',
      collectionTaglineItem_1: 'položky',
      collectionTaglineItem_2: 'položek',
      collectionTaglineSaved: 'uloženo',
      loadErrorMessage: 'Nelze načíst další položky. Prosím zkuste to znovu později.',
      loadNext: 'Načíst další'
    }
  },
  nextCore: {
    signIn: {
      errorLineOne: 'Hledáte něco konkrétního?',
      errorLineTwo: 'Vyzkoušejte',
      errorLineThree: 'přihlášení',
      errorLineFour: 'k zobrazení webové stránky.',
      errorLineFive: 'Ještě jste si nevytvořili svůj bezplatný účet?',
      errorLineSix: 'Přidejte se k nám'
    }
  },
  postCreator: {
    confirmation: {
      metaTitle: 'Vytvořte recept - Děkujeme',
      newRecipeButtonText: 'Nový recept',
      ownRecipeButtonText: 'Moje recepty'
    },
    create: {
      metaTitle: 'Vytvořit recept'
    },
    edit: {
      editFormTitle: 'Upravit recept',
      metaTitle: 'Upravit recept'
    },
    recipeDetails: {
      dropDownOptions: {
        hours: 'hod',
        mins: 'min'
      },
      heading: 'Podrobnosti o receptu',
      label: {
        cookTime: 'Čas vaření (přibližně)',
        difficulty: 'Náročnost',
        extraTime: 'Dodatečný čas (volitelný)',
        image: 'Obrázek',
        prepTime: 'Čas přípravy (přibližně)',
        servings: 'Porce',
        shortIntro: 'Krátký úvod (10-15 slov)',
        title: 'Název receptu (krátký a popisný)'
      },
      placeholder: {
        extraTime: 'např. plus na odležení',
        makes: 'např. 8 kusů',
        serves: 'např. 4',
        shortIntro: 'Řekněte nám něco o svém receptu',
        title: 'např. Ořechový závin od mámy'
      },
      servingsButton: {
        makes: 'Získáte',
        serves: 'Porce'
      },
      skillLevel: {
        dropDownOptions: {
          challenge: 'Výzva',
          defaultText: '(Prosím, zvolte jeden)',
          easy: 'Snadné',
          moreEffort: 'Více úsilí'
        }
      }
    },
    recipeForm: {
      defaultFeedback: {
        error: 'Ups, něco se pokazilo',
        info: 'Prosím, před odesláním uložte obrázek.'
      },
      links: {
        back: 'Zpět na moje recepty',
        preview: 'Náhled',
        saveDraft: 'Uložit koncept'
      }
    },
    recipeIngredients: {
      heading: 'Suroviny',
      information: {
        lineOne: 'Prosím, pokud je to možné, použijte metrický systém (máme praktickou',
        lineTwo: 'průvodce převodem jednotek',
        lineThree: 'pomůcku)',
        lineFour: 'Suroviny můžete rozdělit na skupiny, například na omáčku, na náplň a podobně.'
      },
      ingredient: {
        buttonText: 'Přidat další surovinu',
        label: 'Surovina',
        placeholder: '500 g kuřecích stehen, nakrájených na kostky'
      },
      ingredientGroup: {
        buttonText: 'Vložte nadpis pro skupinu',
        heading: 'Nadpis',
        placeholder: 'Na omáčku'
      }
    },
    recipeMethodSteps: {
      heading: 'Postup',
      method: {
        buttonText: 'Přidat další krok',
        label: 'Krok',
        placeholder: 'Nejdříve uvařte rýži'
      }
    },
    statusFeedback: {
      createLinkeText: 'Vytvořit nový recept',
      info: {
        approved: 'Váš recept byl schválený',
        "default": 'Ups, něco se pokazilo',
        draft: 'Váš recept ještě nebyl odeslán',
        pending: 'Váš recept čeká na schválení',
        rejected: 'Váš recept nebyl schválený'
      },
      submissionChoice: {
        approved: 'zobrazit váš recept',
        "default": 'zpět na moje recepty',
        draft: 'pokračovat v editaci vašeho receptu',
        heading: 'Možná chcete'
      },
      submittedText: 'Váš recept byl odeslán ke schválení a už jej nelze editovat.'
    },
    submit: {
      formValidation: {
        defaultMessage: 'Prosím, potvrďte souhlas s našimi podmínkami'
      },
      informationLineOne: 'Prosím, vkládejte pouze své vlastní recepty.',
      informationLineTwo: 'Z důvodu autorských práv nebudeme moci zveřejnit žádné nahrané recepty',
      informationLineThree: 'Vezměte prosím na vědomí, že byste měli nahrávat pouze své vlastní recepty. Z důvodu autorských práv nebudeme moci zveřejňovat žádné recepty nahrané našimi uživateli, které byly opsány z jiného zdroje. Před odesláním receptu si můžete pro více informací přečíst naše zásady a obchodní podmínky.',
      informationLineFour: 'zásady a podmínky',
      informationLineFive: 'pro více informací před odesláním receptu.',
      metaTitle: 'Vytvořit recept - zásady a podmínky',
      previewButtonText: 'Náhled',
      publishButtonText: 'Publikovat',
      termsLabel: 'Zaškrtnutím potvrďte, že jste si přečetli naše obchodní podmínky'
    }
  }
};